//LIST SHOULD LOOK LIKE THIS
//data-list value is set for the filter
//Use that value as a value of data-target in data-filterForm elem


/*
    <div class="loading" data-list="polishExperts" data-list-wrapper data-post_type="expert" data-posts_per_page="9" data-pagination="true" data-template="expert-box" data-itemclass="secondaryBorder" data-action="getList" data-metakey="localization" data-metavalue="local">
        <div data-list-content class="box-list"></div>
    </div>
*/


//FILTER SHOULD LOOK LIKE THIS

/*

        <form class="filterWrapper" data-filterForm data-target="polishExperts">
            <div class="filter-elem__wrapper">
                <label><?php _e('Task force', 'ncn'); ?></label>
                <div class="filter-elem customSelect">
                    <?php
                        $terms = get_terms( array(
                            'taxonomy'   => 'task_force',
                            'hide_empty' => false,
                        ) );
                    ?>
                    <select name="task_force" class="first-option-placeholder show-content" data-filter data-filterType="taxonomy">
                        <option value=""><option>
                        <?php foreach ($terms as $term): ?>
                            <option value="<?php echo $term->slug; ?>"><?php echo $term->name; ?></option>
                        <?php endforeach; ?>
                    </select>
                </div>
            </div>
            <div class="filter-elem__wrapper">
                <label><?php _e('Główna afiliacja eksperta', 'ncn'); ?></label>
                <div class="filter-elem customSelect">
                    <?php
                        $terms = get_terms( array(
                            'taxonomy'   => 'affiliation',
                            'hide_empty' => false,
                        ) );
                    ?>
                    <select name="task_force" class="first-option-placeholder show-content" data-filter data-filterType="taxonomy">
                        <option value=""><option>
                        <?php foreach ($terms as $term): ?>
                            <option value="<?php echo $term->slug; ?>"><?php echo $term->name; ?></option>
                        <?php endforeach; ?>
                    </select>
                </div>
            </div>
            <div class="filter-elem__wrapper">
                <a href="#" data-filterSubmit class="btn btn--secondary btn--withArrow">
                    <span class="btn__label">
                        <?php _e('Zastosuj filtr', 'ncn'); ?>
                    </span>
                    <span class="btn__arrow"></span>
                </a>
            </div>
        </form>

*/



export default class List {

    constructor(list) {
        this.list = list;
        this.init();
    }

    init() {
        this.initList(this.list);
        this.list_filter = document.querySelector('[data-target="' + this.list.getAttribute('data-list') + '"]');
        if( this.list_filter ) {
            this.initFiltersActions();
        }
    }

    initFiltersActions() {
        let submit = this.list_filter.querySelector('[data-filterSubmit]');
        let _this = this;

        if( submit ) {
            submit.addEventListener('click', function(e) {
                e.preventDefault();

                let params = Object.assign({}, _this.list.dataset);
                params.filters = _this.getFilterValues(_this.list_filter);
                params.paged = 1;

                _this.makeRequest(_this.list, params);
            });
        }
    }

    initList(list) {
        let params = list.dataset;
        if(list.getAttribute('data-oninit') != 'false') {
            this.makeRequest(list, params);
        } else {
            this.paginationHandler(list);
            this.initLightbox();
        }
    }

    getFilterValues(filter) {
        let inputs = filter.querySelectorAll('[data-filter]');
        let values = [];

        if( inputs.length ) {
            inputs.forEach(function(filter) {
                values.push({
                    name: filter.getAttribute('name'),
                    value: filter.value,
                    type: filter.getAttribute('data-filterType')
                })
            })
        }

        return values;
    }

    makeRequest(list, params) {
        const AJAX_URL = php_vars.ajaxUrl;
        let _this = this;
        let container = list.querySelector("[data-list-content]");

        jQuery.ajax({
            type: 'post',
            url: AJAX_URL,
            data: params,
            beforeSend: function () {
                container.innerHTML = '';
                list.classList.add('loading');
            },
            error: function (error) {
                console.log(error);
            },
            success: function (response) {
                list.classList.remove('loading');
                container.innerHTML = response;
                setTimeout(function() {
                    if (params.template =="gallery-box" ) {
                        _this.initLightbox();
                    }
                    _this.paginationHandler(list);

                }, 10);
            }
        });
    }

    paginationHandler(list) {
        let params = Object.assign({}, list.dataset);
        let _this = this;

        let links = list.querySelectorAll('[data-paginationlinks] a');
        if( links ) {
            links.forEach(function (item) {
                item.addEventListener('click', function (e) {
                    e.preventDefault();
                    list.scrollIntoView({ behavior: "smooth", block: "start" });

                    let url_string = item.getAttribute('href');
                    let url = new URL(url_string);

                    params.paged = url.searchParams.get("paged");

                    if (_this.list_filter) {
                        params.filters = _this.getFilterValues(_this.list_filter);
                    }

                    if( params.paged == 'null' ) {
                        let splittedUrl = url_string.split('/');
                        params.paged = splittedUrl[splittedUrl.length - 1] != '' ? splittedUrl[splittedUrl.length - 1] : splittedUrl[splittedUrl.length - 2];
                    }

                    _this.makeRequest(list, params);
                });
            });
        }
    }

    initLightbox() {
        new VenoBox({
            selector: "[data-gallery]"
        });
    }

}


//////////////////
// WEBPACK FOOTER
// ./js/components/list.js
// module id = 14
// module chunks = 0